import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=a2174782&scoped=true"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"
import style0 from "./culture.vue?vue&type=style&index=0&id=a2174782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2174782",
  null
  
)

export default component.exports